<template>
  <div>
    <input
      :type="type"
      class="form-control"
      :class="{ 'is-invalid': hasErrors, [colClass]: true }"
      :name="attribute.name"
      :id="attribute.name"
      v-model="modelValue"
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
    />
    <div
      v-if="attribute.errors !== null"
      v-for="error in attribute.errors"
      :key="error"
      class="invalid-feedback"
    >
      {{ error }}
    </div>
    <button type="button" @click="generateCode" class="btn">
      Code generieren
    </button>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: {
      required: true,
    },
    attribute: {
      required: true,
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      modelValue: this.value,
      codeLength: 12
    };
  },
  computed: {
    colClass() {
      const col = this.attribute.col !== undefined ? this.attribute.col : 12;
      return `col-${col}`;
    },
    hasErrors() {
      return this.attribute.errors.length !== 0;
    },
    type() {
      return this.attribute.type;
    }
  },
  methods: {
    generateCode() {
      let code = "";
      let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < this.codeLength; i++) {
        code += possible.charAt(Math.floor(Math.random() * possible.length));
      }

      this.modelValue = code;
      this.$emit('input', code)
    }
  }
}
</script>
